import { render } from "./PageDataSourcePopover.vue?vue&type=template&id=9468897a"
import script from "./PageDataSourcePopover.vue?vue&type=script&lang=js"
export * from "./PageDataSourcePopover.vue?vue&type=script&lang=js"

import "./PageDataSourcePopover.vue?vue&type=style&index=0&id=9468897a&lang=scss"

import exportComponent from "/app/tmp/360pt/V3/v2026.21.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__